import { useContext } from "react";

import axios from "axios";

import useToast from "@hooks/useToast";
import { useNavigate } from 'react-router-dom'

import ActiveYearContext from '@context/ActiveYearContext'

const multiPart = { headers: { 'content-type': 'multipart/form-data' } }

function getCookie(name) {
    let cookieValue = null;

    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();

            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

/**
	* @param {boolean} isDisplay Toast гаргах эсэх
 */
function useApi(isDisplay=false) {

	// Toast нэмэх функц
	const addToast = useToast()

	const navigate = useNavigate()
	const { cyear_name, cseason_id } = useContext(ActiveYearContext)

	const source = axios.CancelToken.source();
	const instance = axios.create({
		baseURL: process.env.REACT_APP_SERVER_URL,
		withCredentials: true, // Хүсэлт болгонд ээр cookie явуулах нь
		cancelToken: source.token,
		headers: {
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json; charset=UTF-8",
		},
	});
    instance.defaults.headers.put['X-CSRFToken'] = getCookie('csrftoken')
    instance.defaults.headers.post['X-CSRFToken'] = getCookie('csrftoken')
    instance.defaults.headers.delete['X-CSRFToken'] = getCookie('csrftoken')

	/*
        Response дата
    */
	instance.interceptors.response.use(
		function (rsp) {
			const data = rsp?.data;
			const text = data?.info
			// хүсэлт амжилттай болоод info ирэх үед
			if (data?.success && text) {
				var type = 'success'
				if (!isDisplay) {
					if (data.code === "INF_007") {
						type='warning'
					}

					addToast(
						{
							type: type,
							text: text
						}
					)
				}
			}
			else if(!data?.success) {
				// Toast дээр error харуулах
				const err_message = data.error
				if (!isDisplay && err_message) {
					addToast(
						{
							type: 'error',
							text: err_message
						}
					)
				}
			}

			return data

		},
		function (error) {
			var err = error?.response?.data
			var status_code = error?.response?.status

            if ([401, 403].indexOf(status_code) !== -1) {
                navigate('/login')
            } else {
				if (!isDisplay) {
					addToast(
						{
							type: 'error',
							text: err?.message || 'Алдаа гарлаа. Системийн админд хандана уу.'
						}
					)
				}
            }
            return Promise.reject(err);
        }
    );

	return {
		source,
		instance,

		//  Хэрэглэгчийн мэдээлэл
		user: {
            logged: () => instance.get('/user/logged/'),
			login: (data) => instance.post(`/user/login/`, data),
			logout: () => instance.get(`/user/logout/`),
			firstCheckLogged: () => instance.get('user/first_logged/'),
			changepass: (pk, data) => instance.put(`/user/change_pass/${pk}/`, data),
			forgotPassword: (data) => instance.post(`/user/forgot-password`, data),
			resetPassword: (token, data) => instance.post(`/user/reset-password/${token}/`, data),
			studyContract:(pk)=>instance.get(`user/contract/${pk}/`),
			submitContract:(pk,data)=>instance.post(`user/contract/${pk}/`,data),
		},
		admissionuser: {
			login: (data) => instance.post(`/user/admission-login/`, data),
			logout: () => instance.get(`/user/admission-logout/`),
		},
		student: {
			get: () => instance.get(`/student/info/`),
			getOne: (pk) => instance.get(`/student/info/${pk}/`),
			calculateGpaDimplomaGet: (studentId='') => instance.get(`/student/gpa-diploma-values/?id=${studentId}`),
			checkGraduation: (studentId='') => instance.put(`/student/check-graduation/?id=${studentId}`),
			getConfig: (group='', type) => instance.get(`/student/calculate-gpa-diploma/config/?group=${group}&type=${type}`),

			survey: {
				get: ({ page=1, limit='Бүгд', surveyType='' }) => instance.get(`/student/survey/?page=${page}&limit=${limit}&surveyType=${surveyType}`),
				post: (data) => instance.post(`/student/survey/`, data),

				soul: {
					get: ({ page=1, limit='Бүгд', sorting='', surveyId='' }) => instance.get(`/student/survey/soul/?page=${page}&limit=${limit}&sorting=${sorting}&surveyId=${surveyId}`),
				}
			},

			payment: {
				get: (pk) => instance.get(`/student/payment/${pk}/?year=${cyear_name}&season=${cseason_id}`)
			},
			score: {
				get:(student_id) =>
					instance.get(`/student/score/${student_id}/`),
				getTeacher:() =>
					instance.get(`/student/score-teacher/`)
			},
			allscore: {
				get:(student_id) =>
					instance.get(`/student/allscore/${student_id}/`),
			},
			/** Дотуур байр */
			dormitory: {
				/** Хүсэлт */
				get: (student='', admission='') => instance.get(`/student/dormitory/?student=${student}&admission=${admission}`),
				getOne: (pk) => instance.get(`/student/dormitory/${pk}/`),
				post: data => instance.post(`/student/dormitory/`, data),
				put: (data, pk) => instance.put(`/student/dormitory/${pk}/`, data, multiPart),
				/** Өрөөний төрөл */
				type: {
					get: (building='') => instance.get(`/student/dormitory/type/?building=${building}`),
				},
				/** Өрөө */
				room: {
					get: (room_type, gender='', building='') => instance.get(`/student/dormitory/room/${room_type}/?gender=${gender}&building=${building}`),
				},

				contract:{
					get:(pk, buildingId, is_admission)=>instance.get(`/student/dormitory/contract/${pk}/?buildingId=${buildingId}&is_admission=${is_admission}`),
					post:(pk, data)=>instance.post(`/student/dormitory/contract/${pk}/`, data)
				},

				/** Дотуур байрны хичээлийн байр */
				building: {
					getList: () => instance.get(`/student/dormitory/building/list/`)
				},

				check: {
					get: () => instance.get(`/student/dormitory/order`)
				}
			},
			/** Дүнгийн мэдээлэл */
			scoreregister: {
				get: (student_id) => instance.get(`/student/scoreregister/${student_id}/?year=${cyear_name}&season=${cseason_id}`),
				get2: (id) => instance.get(`/student/score-register/?id=${id}`),
			},
			schedule: {
				get:(student_id,start='',end='',month='') => instance.get(`/student/schedule/${student_id}/?year=${cyear_name}&season=${cseason_id}&start=${start}&end=${end}&month=${month}`),
			},
			regirts: {
				get: () => instance.get(`/student/irts/`)
			},
			/** санал болгох төлөвлөгөө */
			learningplan: {
				get:() => instance.get(`/student/plan/?year=${cyear_name}&season=${cseason_id}`),
			},
			// Хичээлийн талаар дэлгэрэнгүй мэдээлэл харах API. Хүссэн газраа ашиглаж болно
			lessondetail: {
				get:(lesson_id) => instance.get(`/student/plan/lessondetail/${lesson_id}`),
			},
			/** Шалгалтын хуваарь */
			examtimetable: {
				get:(student_id) => instance.get(`/student/examtimetable/${student_id}/?year=${cyear_name}&season=${cseason_id}`),
			},
			/** Хувийн мэдээлэл */
			information: {
				get:(student_id) => instance.get(`/student/personalinformation/${student_id}/`),
				put: (data, student_id) => instance.put(`/student/personalinformation/${student_id}/`, data),

				address: {
					get:(student_id) => instance.get(`/student/address/${student_id}/`),
					post: (data, student_id) => instance.post(`/student/address/${student_id}/`, data)
				},
				family: {
					get:(student_id) => instance.get(`/student/family/${student_id}/`),
					post: data => instance.post(`/student/family/`, data),
					put: (data, pk, student) => instance.put(`/student/family/${student}/${pk}/`, data),
					delete: (student, pk) => instance.delete(`/student/family/${student}/${pk}/`)
				},
				education: {
					get:(student_id) => instance.get(`/student/education/${student_id}/`),
				}
			},
			/** Төлбөрийн дэлгэрэнгүй */
			paymentdetail: {
				get:(student_id) => instance.get(`/student/paymentdetail/${student_id}/`),
				getTransiction:(student_id) => instance.get(`/student/paymentdetail/transiction/${student_id}/`),
			},
			/** ИБаримт */
			ebarimt: {
				send: (data) => instance.post(`/ebarimt/sendlist/`, data),
				getTinInfo: (regNo) => instance.get(`/ebarimt/tin/info/?regNo=${regNo}`),
			},
			/** Олон нийтийн ажилд оролцох оюутны хүсэлт*/
			request:{
			// 	volunteer: {
			// 		get:(student_id,limit, page, sorting, search) => instance.get(`/student/request/volunteer/${student_id}/?page=${page}&limit=${limit}&sorting=${sorting}&search=${search}&year=${cyear_name}&season=${cseason_id}`),
			// 		getOne: (student_id, pk) => instance.get(`/student/request/volunteer/${student_id}/${pk}/?year=${cyear_name}&season=${cseason_id}`),
			// 		post:  data => instance.post(`/student/request/volunteer/?year=${cyear_name}&season=${cseason_id}`, data),
			// 		put: (data, student_id, pk) => instance.put(`/student/request/volunteer/${student_id}/${pk}/?year=${cyear_name}&season=${cseason_id}`, data),

			// 	},
				club: {
					get:(limit, page, sorting, student_id) => instance.get(`/student/request/club/?page=${page}&limit=${limit}&sorting=${sorting}&student_id=${student_id}`),
					getOne: (pk) => instance.get(`/student/request/club/${pk}/`),
					post: data => instance.post(`/student/request/club/`, data),
					put: (data, pk) => instance.put(`/student/request/club/${pk}/`, data),
					getType:(student_id='') => instance.get(`/student/request/club/type/?student_id=${student_id}`),
				},
			// 	tutor: {
			// 		get:(limit, page, sorting) => instance.get(`/student/request/tutor/?page=${page}&limit=${limit}&sorting=${sorting}`),
			// 		getOne: (pk) => instance.get(`/student/request/tutor/${pk}/`),
			// 		post: (data) => instance.post(`/student/request/tutor/`, data),
			// 		put: (data, pk) => instance.put(`/student/request/tutor/${pk}/`, data),
			// 		getLesson:(student_id) => instance.get(`/student/request/tutor/lesson/?student_id=${student_id}`),
			// 		getTeacher:(student_id, lesson_id) => instance.get(`/student/request/tutor/teacher/?student_id=${student_id}&lesson_id=${lesson_id}`),
			// 	},
			},

			complaint: {
				register: {
					get: (limit, page, sort, search, menuId) => instance.get(`/student/complaint/register/?page=${page}&limit=${limit}&sorting=${sort}&search=${search}&menu_id=${menuId}`),
					getOne: (pk) => instance.get(`/student/complaint/register/${pk}/`),
					post: (data) => instance.post(`/student/complaint/register/`, data),
					delete: (pk) => instance.delete(`/student/complaint/register/${pk}/`),
				},

				leave: {
					get: (limit, page, sort, search, student_id, flagNumber, type ) => instance.get(`/student/complaint/leave/${student_id}/?page=${page}&limit=${limit}&sorting=${sort}&search=${search}&flag=${flagNumber}&type=${type}`),
					post: (student_id, data, pk) => instance.post(`/student/complaint/leave/${student_id}/?id=${pk}`, data),
					delete: (student_id, pk) => instance.delete(`/student/complaint/leave/${student_id}/${pk}/`),
				},

				movement: {
					get: (limit, page, sort) => instance.get(`/student/movement/?page=${page}&limit=${limit}&sorting=${sort}`),
					getSchool: () => instance.get(`/student/school/`),
					getProfession: (school_id) => instance.get(`/student/profession/?school=${school_id}`),
					post: (data) => instance.post(`/student/movement/`, data),
					delete: (id) => instance.delete(`/student/movement/${id}/`)
				}
			},

			// Үзэж байгаа хичээлийн хуваарь
			lesson: {
				get:(pk) => instance.get(`/student/lesson/list/${pk}/?year=${cyear_name}&season=${cseason_id}`),
				getOne: (lessonId) => instance.get(`/student/lesson/getone/${lessonId}/`),
				getMaterials: (lessonId, weekId) => instance.get(`/student/lesson/materials/${lessonId}/?week=${weekId}`),
				getMaterialList: (lessonId) => instance.get(`/student/lesson/materiallist/${lessonId}/`),
				getScoretype: (lessonId, teacherInfo) => instance.get(`/student/lesson/scoretype/${lessonId}/${teacherInfo}/`),

				times: {
					get: (lesson='', teacher='') => instance.get(`/student/lesson/times/?lesson=${lesson}&teacher=${teacher}`),
					post: (data) => instance.post(`/student/lesson/times/`, data),
					put: (data, id) => instance.put(`/student/lesson/times/${id}/`, data),
					delete: (pk) => instance.delete(`/student/lesson/times/${pk}/`),
				},


				challenge: {
					get: (pk) => instance.get(`/student/lesson/challenge/${pk}/`),
					getStartTime: (pk) => instance.get(`/student/lesson/challenge/time/${pk}/`),
					post: (pk, data) => instance.post(`/student/lesson/challenge/${pk}/`, data)
				},

				homework: {
					getResult: (assignment_id, studentId) => instance.get(`/student/lesson/homework/${studentId}/${assignment_id}/result`),
					post: (studentId, assignment_id, data) => instance.post(`/student/lesson/homework/${studentId}/${assignment_id}/`, data),
					getFile: (studentId, assignment_id) => instance.get(`/student/lesson/homework/${studentId}/${assignment_id}/`),
					deleteFile: (studentId, assignment_id, file_id) => instance.get(`/student/lesson/homework/${studentId}/${assignment_id}/${file_id}`),
					submitFile: (studentId, homeWorkId) => instance.put(`/student/lesson/homework/${studentId}/${homeWorkId}/sended`),
				},
				custom: {
					// get:(pk, lesson) => instance.get(`/student/lesson/customlist/${pk}/?${lesson}year=${cyear_name}&season=${cseason_id}`),
					get:(pk, lesson) => instance.get(`/student/lesson/customlist/${pk}/?${lesson}year=&season=`),
				},
			},

			/** Тодорхойлолт */
			definition: {
				get: (code, type) => instance.get(`/student/definition/?definition_type=${type}&code=${code}`),
				getYear: (code) => instance.get(`/student/definition/season/option?code=${code}`),
				getSum: (data, code) => instance.post(`student/definition/sum/?code=${code}`, data),
				getCheck: (data) => instance.post(`student/definition/check/`, data)
			},

			/** Захиалга */
			order: {

				// Номын каталог
				libraryCatalog:{
					get: (pk, search, page, limit) => instance.get(`/student/order/book/librarycatalog/${pk}/?search=${search}&page=${page}&limit=${limit}`)
				},

				// Цахим номын каталог
				ebookCatalog:{
					get: (search, page, limit, startDate, endDate, keyword, checkBoxState) => instance.get(`/student/order/book/ebook-catalog/?search=${search}&page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&keyword=${keyword}&checkBoxState=${checkBoxState}`),
					getSearchPoint: () => instance.get(`/student/order/book/ebook-catalog/searchpoint/`),
					getOne: (pk) => instance.get(`/student/order/book/ebook-catalog/getone/${pk}/`),
				},

				// Цахим номын хүсэлт
				ebookRequest: {
					get: (student_code, search, page, limit) => instance.get(`/student/order/ebookrequest/${student_code}/?search=${search}&page=${page}&limit=${limit}`),
					getOne: (pk) => instance.get(`/student/order/ebookrequest/one/${pk}/`),
					put: (data, pk) =>instance.put(`/student/order/ebookrequest/one/${pk}/`, data),
				},

				// Номын нэг бүрчилсэн бүртгэл
				bookVolume:{
					get: (student_id) => instance.get(`/student/order/book/librarycatalog/bookvolume/?student_id=${student_id}`)
				},

			// 	/** Спорт заал */
			// 	sport: {
			// 		get: (room_id) => instance.get(`/student/order/sport/?room_id=${room_id}`),
			// 		put: (data) => instance.put(`/student/order/sport/`, data),

			// 		// Захиалгын түүх
			// 		getHistory: (limit, page, sort, search, student, is_today) => instance.get(`/student/order/sport/history/${student}/?page=${page}&limit=${limit}&sorting=${sort}&search=${search}&is_today=${is_today}`),
			// 		revokeOrder: (student, revokeIds) => {
			// 			var revoke_ids = ''
			// 			for(var i of revokeIds) {
			// 				revoke_ids += `&revokeIds=${i}`
			// 			}
			// 			return instance.put(`/student/order/sport/history/${student}/?${revoke_ids}`)
			// 		},
			// 	},
			// 	gym: {
			// 		// Фитнесийн сургалтын жагсаалт
			// 		getGymList: (limit, page, sort) => instance.get(`/student/order/gym/list/?page=${page}&limit=${limit}&sorting=${sort}`),

			// 		// Фитнест хүсэлт илгээх
			// 		requestGymOrder: data => instance.post(`/student/order/gym/request/list/`, data),

			// 		// Оюутаны хүсэлт өгсөн фитнесийн жагсаалт
			// 		getRequestGymList: (student, is_time='') => instance.get(`/student/order/gym/request/list/${student}/?is_time=${is_time}`),

			// 		// Фитнесийн захиалгаа түр зогсоох
			// 		stopGymRequest: (student, data) => instance.put(`/student/order/gym/request/list/${student}/`, data),

			// 		// Фитнест хичээллэх цаг
			// 		get: (limit, page, sort, search, flag_id, is_today, student, gym_id) => instance.get(`/student/order/gym/time/${student}/?page=${page}&limit=${limit}&sorting=${sort}&search=${search}&flag=${flag_id}&is_today=${is_today}&gym_id=${gym_id}`),
			// 		post: data => instance.post(`/student/order/gym/time/`, data),
			// 		put: (student, pk, is_refresh, data) => instance.put(`/student/order/gym/time/${student}/${pk}/?is_refresh=${is_refresh}`, data),

			// 	},
			// 	/** эмнэлэгт цаг захиалах */
			// 	hospital: {
			// 		get: (limit, page, sort, search, student, is_today, flag_id) => instance.get(`/student/order/hospital/${student}/?page=${page}&limit=${limit}&sorting=${sort}&search=${search}&is_today=${is_today}&flag=${flag_id}`),
			// 		getOne: (student, pk) => instance.get(`/student/order/hospital/${student}/${pk}/`),
			// 		post: (data) => instance.post(`/student/order/hospital/`, data),
			// 		put: (data, student, pk, is_refresh='') => instance.put(`/student/order/hospital/${student}/${pk}/?is_refresh=${is_refresh}`, data),
			// 	},

				/** Номын санд цаг захиалах */
				library: {
					get: (limit, page, sort, search, student, is_today, flag_id) => instance.get(`/student/order/library/${student}/?page=${page}&limit=${limit}&sorting=${sort}&search=${search}&is_today=${is_today}&flag=${flag_id}`),
					getOne: (student, pk) => instance.get(`/student/order/library/${student}/${pk}/`),
					getData: (student) => instance.get(`/student/order/library/services/${student}/`),
					post: (data) => instance.post(`/student/order/library/`, data),
					put: (data, student, pk, is_refresh='') => instance.put(`/student/order/library/${student}/${pk}/?is_refresh=${is_refresh}`, data),
				},

				/** Авсан номын жагсаалт харах*/
				services: {
					get: (limit, page, sort, search, reader) => instance.get(`/student/order/book/${reader}/?limit=${limit}&page=${page}&sorting=${sort}&search=${search}`),
					getOne: (pk) => instance.get(`/student/order/book/student/${pk}/`),
					post: (data) => instance.post(`/student/order/book/`, data),
				},

				keepservice: {
					put: (data, pk) =>instance.put(`/student/order/book/student/request/${pk}/`, data),
				}
			}
		},

		surgalt: {
			getPlan: (student) => instance.get(`/surgalt/learningplan/${student}`),
			getChoice: (lesson) => instance.get(`/surgalt/choice/${lesson}`),
			getChoiceApprove: () => instance.get(`/surgalt/choice/approve/`),
			getChoiceLesson: (student_id) => instance.get(`/surgalt/choice-lesson/${student_id}`),
			getChoiceLessonF: (studentId) => instance.get(`/surgalt/choice-lesson-f/`),
			getChoiceLessonKR: () => instance.get(`/surgalt/choice-lesson-kr/`),
			postChoice: (data) => instance.post(`/surgalt/choice/approve/`, data),
			postChoiceLessonKR: (cdata) => instance.post(`/surgalt/choice-lesson-kr/`, cdata),
			postChoiceLessonF: (cdata) => instance.post(`/surgalt/choice-lesson-f/`, cdata),
		},

		qpay: {
			create: (student, datas) => instance.post(`/student/qpay/create/${student}/`, datas),
			check: (payment) => instance.get(`/student/qpay/check-pay/${payment}/`),
			exitCheckPayment: (payment) => instance.get(`/student/qpay/exit/${payment}/`),
		},

		activeyear: {
			get: () => instance.get(`/lms/activeyear/`)
		},

		/** Сургалтын хуанли харуулах api */
		calendar: {
			get: (scope) => instance.get(`/lms/calendar/?scope=${scope}`),
			getVolunteer: (student_id, event_id)=> instance.get(`/lms/calendar/volunteer/${student_id}/${event_id}`)
		},

		hrms: {
			/** Улс */
			country: {
				get: () => instance.get(`/core/country/`),
				getOne: (pk) => instance.get(`/core/country/${pk}/`),
			},
			/** Аймаг */
			unit1: {
				get: () => instance.get(`/core/aimaghot/`),
				getOne: (pk) => instance.get(`/core/aimaghot/${pk}/`),
			},
			/** Сум */
			unit2: {
				get: (unit1) => instance.get(`/core/sumduureg/${unit1}/`),
				getOne: (pk) => instance.get(`/core/sumduureg/${pk}/`),
			},
			/** Баг */
			unit3: {
				get: (unit2) => instance.get(`/core/baghoroo/${unit2}/`),
				getOne: (pk) => instance.get(`/core/baghoroo/${pk}/`),
			},
			/** Өрөө */
			room: {
				get: (room_type='') => instance.get(`/core/room/?room_type=${room_type}`),
			},
		},
		/** Тэтгэлэг */
		stipend: {
			get: (student='', limit, page, sort) => instance.get(`/stipend/list/?student=${student}&page=${page}&limit=${limit}&sorting=${sort}&lesson_year=${cyear_name}&lesson_season=${cseason_id}`),
			post: (data) => instance.post(`/stipend/student_request/`, data),

			/** Өөрийн илгээсэн хүсэлт */
			getRequestOne: (pk) => instance.get(`/stipend/student_request/${pk}/`),
			put: (pk, data) => instance.put(`/stipend/student_request/${pk}/`, data),
			getRequest: (student, limit, page, sort, search) => instance.get(`/stipend/student_request/${student}/?lesson_year=${cyear_name}&lesson_season=${cseason_id}&page=${page}&limit=${limit}&sorting=${sort}&search=${search}`),

			/** Хавсаргасан файл засах үед хадгалах api */
			fileChange: (pk, data) => instance.put(`/stipend/student_request/file/${pk}/`, data),
		},
		/** Чат */
		chat: {
			/** Чатлах боломжтой хэрэглэгч хайх */
			searchUser: (data) => instance.get(`/user/search/?name=${data}`),
			/** Тухайн чат өөрөөний дата авах */
			roomData: (user_id) => instance.get(`/chat/users/${user_id}/chats`),
			/** Тухайн хэрэглэгчтэй холоотой чат өрөөний мэдээллүүдийг авах нь */
			getRooms: () => instance.get('/chat/chats'),
			/** Check room */
			checkRoom: (data) => instance.post('/chat/chats', data),
			/** Чатьн дата авах */
			getChatData: (roomId, lastId) => instance.get(`/chat/chats/${roomId}/messages/?lastId=${lastId}`),
		},

		/** Зар мэдээ */
		news: {
			get: (scope, student_level, page, limit, is_news) => instance.get(`lms/news/?scope=${scope}&student_level=${student_level}&page=${page}&limit=${limit}&is_news=${is_news}`),
			getOne: (pk) => instance.get(`lms/news/${pk}/`),

		},
		onlineLesson:{
			get: (lessonId) => instance.get(`/surgalt/onlinelesson/?lesson=${lessonId}&year=${cyear_name}&season=${cseason_id}`),
		}
    }
}

export default useApi;
